import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  DATA_START_ROW,
  HEADER_FILL,
  HEADER_ROW,
  TABLE_HEADER_FILL,
  TITLE_ROW,
} from "./principle1DetailHelpers";

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const SHEET_TITLE =
  "Action taken to mitigate significant social or environmental concerns and/or risks arising from production or disposal of products / services";

export const SHEET_NAME = "Action taken";

const HEADERS = [
  { col: COL_D, label: "Sr. No.", width: 8 },
  { col: COL_E, label: "Name of Product/Service", width: 20 },
  { col: COL_F, label: "Description of the risk/concern", width: 28 },
  { col: COL_G, label: "Action Taken", width: 24 },
];

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: options.vertical || "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function setColumnWidths(ws) {
  const widths = { A: 2, B: 2, C: 2 };
  HEADERS.forEach(({ col, width }) => {
    widths[String.fromCharCode(64 + col)] = width;
  });
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });
}

export function buildActionTakenSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setColumnWidths(ws);
  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_2, { mergeEnd: COL_G });

  ws.mergeCells(TITLE_ROW, COL_D, TITLE_ROW, COL_G);
  setCell(ws, TITLE_ROW, COL_D, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  HEADERS.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      bold: true,
      fill: TABLE_HEADER_FILL,
      align: "center",
    });
  });

  const rows = Array.isArray(sectionC?.principle2?.leadershipIndicator?.significantRisksFromLCA)
    ? sectionC.principle2.leadershipIndicator.significantRisksFromLCA
    : [];
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, item?.productName || "-", { align: "left" });
    setCell(ws, row, COL_F, item?.descriptionOfRisk || "-", { align: "left", vertical: "top" });
    setCell(ws, row, COL_G, item?.actionTaken || "-", { align: "left", vertical: "top" });
  });

  return ws;
}
